import { CONTENT_VERSION_HEADER } from "@src/constants/content-version.constants"
import { CONTENT_PREVIEW_BLACKLIST_DOMAIN } from "@src/constants/contentPreviewBlacklistDomains"
import isBrowser from "@src/quince-site-common/src/utils/isBrowser"

import type { AxiosRequestHeaders } from "axios"

export function _intersection<T>(left: T[], right: T[], comparator?: (leftItem: T, rightItem: T) => boolean): T[] {
  if (!Array.isArray(left) || !Array.isArray(right)) return []
  if (comparator) {
    return left.filter(leftItem => right.some(rightItem => comparator(leftItem, rightItem)))
  }
  return left.filter(leftItem => right.includes(leftItem))
}

export function disectQueryString(query: string): Record<string, string[]> {
  const searchParams = new URLSearchParams(query)
  const result: Record<string, string[]> = {}
  for (const key of searchParams.keys()) {
    if (searchParams.get(key)) {
      result[key] = searchParams.get(key)?.split(',') ?? []
    }
  }
  return result
}

export function tranformToMap(record: Record<string, string | string[] | undefined>) {
  const result: Record<string, string> = {}
  Object.entries(record).forEach(([key, values]) => {
    if (!values) return
    result[key] = Array.isArray(values) ? values.join(',') : values
  })

  return result
}

export function extractPreviewHash(hostname: string): string | null {
  const regex = /^release-([a-zA-Z0-9]+)\.preview(-qa|-dev)?\.quince\.com$/;
  const match = hostname.match(regex);
  return match?.[1] ?? null;
}

export function isPreviewEnv(hostname: string): boolean { 
  return hostname === 'preview.quince.com' || hostname.endsWith('.preview.quince.com') || hostname === "storefront-ssr-auto-preview-internal.onequince.com"
}


export const getHeadersWithContentVersion = (headers: HeadersInit | AxiosRequestHeaders | undefined, domain?: string): HeadersInit | AxiosRequestHeaders | undefined => { 
  if (!isBrowser()) return headers
  if (domain &&  _intersection(CONTENT_PREVIEW_BLACKLIST_DOMAIN, [domain]).length > 0) return headers // Do not add preview version to blacklisted domains
  const contentVersion = getContentVersionOnClient()
  if (contentVersion) {
    return {
      ...headers,
      [CONTENT_VERSION_HEADER]: contentVersion,
    }
  }
  return headers
}

export const getContentVersionOnClient = (): string | null => {
  // Preview only works on Non-prod hosts ( doesn't work on www.quince.com )
  if (!isBrowser()) return null
  if (isProdHost(window.location.host)) return null
  let contentVersion: string | null = null;
  
  // Extract from storage
  contentVersion = extractPreviewHash(window.location.host)

  if(contentVersion === "latest") return null // if you are on latest version, return null
  return contentVersion || null
}

export const isProdHost = (host: string | undefined): boolean => {
  return host === 'www.quince.com' || host === 'quince.com'
}